export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const APP_API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;
export const APP_V3_API_BASE_URL = import.meta.env.VITE_API_APP_V3_BASE_URL;
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const FLEET_VARIANT = import.meta.env.VITE_FLEET_VARIANT;
export const OPERATOR_CODE = import.meta.env.VITE_OPERATOR_CODE;
export const APP_VERSION = "1.7.5";